import React from 'react'
import styled from '@emotion/styled'

const withStyle = (WrappedLogicSetEditor) => {
  const StyledLogicSetEditor = styled(WrappedLogicSetEditor)((props) => {
    const { fontSize } = props.theme.dimensions.small
    return `
      font-size: ${fontSize};
    `
  })

  return (props) => <StyledLogicSetEditor {...props} />
}

export default withStyle

export const ListLabel = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 10px;
`

export const ConditionsContainer = styled.div`
  margin-top: 20px;
`
